// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Navigation----Navigation-module---wrapper---2NOzV","navigation":"src-components-Navigation----Navigation-module---navigation---h-7dk","name":"src-components-Navigation----Navigation-module---name---1_d8J","socialMedia":"src-components-Navigation----Navigation-module---socialMedia---OSaNT","mobileNav":"src-components-Navigation----Navigation-module---mobileNav---UW4Y3","mobileNavName":"src-components-Navigation----Navigation-module---mobileNavName---1j6FO","mobileNavSocialMedia":"src-components-Navigation----Navigation-module---mobileNavSocialMedia---17cy-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navigation.module.scss
// module id = 256
// module chunks = 79611799117203